import { useEffect, useRef } from 'react'

function usePreserveRightMapAnchorOnResize(map, updateFlag) {
  const mapRightCorner = useRef(null)

  useEffect(() => {
    if (!map) return

    function getRightCorners() {
      mapRightCorner.current = map.unproject([
        map.getContainer().clientWidth,
        map.getContainer().clientHeight / 2,
      ])
    }

    map.on('moveend', getRightCorners)
    return () => map && map.off('moveend', getRightCorners)
  }, [map])

  useEffect(() => {
    if (!map) return

    map.once('resize', () => {
      const newWidth = map.getContainer().clientWidth
      const projected = map.project(mapRightCorner.current)
      const dx = projected.x - map.getContainer().clientWidth
      const targetX = newWidth / 2 + dx
      const targetCenter = map.unproject([targetX, projected.y])

      map.jumpTo({ center: targetCenter })
    })

    mapRightCorner.current = map.unproject([
      map.getContainer().clientWidth,
      map.getContainer().clientHeight / 2,
    ])
  }, [map, updateFlag])

  return mapRightCorner
}

function useMoveLeftMapControlsOnResize(map, sidepanelIsOpening) {
  const prevMap = useRef(map)
  const firstRender = useRef(true)

  useEffect(() => {
    if (map && map !== prevMap.current) {
      firstRender.current = true
    }
  }, [map])

  useEffect(() => {
    if (!map) return
    if (firstRender.current) {
      firstRender.current = false
      return
    }
    const mapContainerElement = map.getContainer()
    const topLeftControls = mapContainerElement.querySelector('.maplibregl-ctrl-top-left')
    const bottomLeftControls = mapContainerElement.querySelector('.maplibregl-ctrl-bottom-left')

    if (sidepanelIsOpening) {
      topLeftControls.style.transform = 'translateX(var(--sidepanel-width))'
      topLeftControls.style.transition = 'transform 0.3s ease'
      bottomLeftControls.style.transform = 'translateX(var(--sidepanel-width))'
      bottomLeftControls.style.transition = 'transform 0.3s ease'
    }
    else {
      topLeftControls.style.transform = 'translateX(var(--sidepanel-width))'
      bottomLeftControls.style.transform = 'translateX(var(--sidepanel-width))'

      setTimeout(() => {
        topLeftControls.style.transform = 'translateX(0)'
        topLeftControls.style.transition = 'transform 0.3s ease'
        bottomLeftControls.style.transform = 'translateX(0)'
        bottomLeftControls.style.transition = 'transform 0.3s ease'
      }, 5)
    }

    setTimeout(() => {
      topLeftControls.style.transform = ''
      topLeftControls.style.transition = ''
      bottomLeftControls.style.transform = ''
      bottomLeftControls.style.transition = ''
    }, 300)
  }, [map, sidepanelIsOpening])
}

export { usePreserveRightMapAnchorOnResize, useMoveLeftMapControlsOnResize }
